import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export default ({ app, store }) => {
  app.i18n = new VueI18n({
    locale: store.state.locale,
    fallbackLocale: 'zh-cn',
    messages: {
      'zh-cn': require('~/locales/zh-cn.json'),
      'zh-hk': require('~/locales/zh-hk.json')
    }
  })

  app.i18n.path = link => {
    // 新老网站衔接，不为news页面的内容则不带前缀
    // if (link.indexOf('news') === -1) {
    //   return `/${link}`;
    // }

    if (app.i18n.locale === app.i18n.fallbackLocale) {
      return `/${link}`
    }

    return `/${app.i18n.locale}/${link}`
  }
}
